import API from "./../index";
import {
  ADD_CAMPAIGN,
  CHANGE_CAMPAIGN_STATUS,
  EDIT_CAMPAIGN,
  FETCH_BRANDS,
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_BY_ID,
  FETCH_CATEGORIES,
  FETCH_COUNTRIES,
  FETCH_PRODUCTS,
} from "./campaign.endpoint";

export const fetchCampaigns = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_CAMPAIGN.replace(":partnerId", partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const addCampaign = (data: any) => {
  return new Promise((resolve, reject) => {
    API.post(
      ADD_CAMPAIGN,
      data,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchCategories = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_CATEGORIES(partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchProducts = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_PRODUCTS(partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchBrands = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_BRANDS(partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchCountries = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_COUNTRIES(partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchCampaignById = (campaignId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_CAMPAIGN_BY_ID(campaignId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const editCampaign = (data: any) => {
  const campaignId = data?.data?.id;

  if (!campaignId) {
    return Promise.reject("Campaign Id is required");
  }

  return new Promise((resolve, reject) => {
    API.post(
      EDIT_CAMPAIGN(campaignId),
      data,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const changeCampaignStatus = (data: any) => {
  const payload: any = {
    data: {
      state: data?.changeTo,
    },
  };

  return new Promise((resolve, reject) => {
    API.post(
      CHANGE_CAMPAIGN_STATUS(data.campaignId),
      payload,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};
